import { query, onSnapshot, where } from 'firebase/firestore'
import { Record } from '@/models/Record'
import {
  getRecordsCollectionSnapShot,
  paymentsCollGroup,
  saveRecord
} from '@/firebase-firestore'
import {
  startOfDay,
  endOfDay
} from 'date-fns'
import { PaidWith, Product, RecordItem } from '@/types'

export default {
  namespaced: true,
  strict: process.env.NODE_ENV !== 'production',
  state: {
    paymentOptions: [
      { text: 'Efectivo', value: 'cash' },
      { text: 'Yappy', value: 'yappy' },
      { text: 'Tarjeta', value: 'card' },
      { text: 'ACH', value: 'ach' },
    ] as { text: string, value: PaidWith }[],
    registerRecords: null,
    registerRecordsListener: null
  },
  mutations: {
    setRegisterRecords(state: any, arr: []) {
      state.registerRecords = arr
    },
    setRegisterRecordsListener(state: any, listener: number) {
      state.registerRunningSubscriptionsListener = listener
    }
  },
  getters: {
    isRegisterReady: (state: any, getters: any, rootState: any) => {
      return Array.isArray(state.registerRecords) &&
        Array.isArray(rootState.products.products)
    },
    registerRecords: (state: any, getters: any, rootState: any, rootGetters: any): RecordItem[] => {
      return getters.isRegisterReady
        ? state.registerRecords
          .map((row: RecordItem) => new Record({
            ...row,
            product: row.productId ? rootGetters['products/getProduct'](row.productId) as Product : undefined
          }))
          .filter((record: Record) => {
            return record.isValid
          })
        : []
    }
  },
  actions: {
    async saveRecord({ commit }: { commit: any }, payload: any) {
      await saveRecord(payload)
    },
    releaseRegisterRecords({ commit, state }: { state: any, commit: any }) {
      if (state.registerRecordsListener) {
        state.registerRecordsListener()
        commit('setRegisterRecordsListener', null)
        commit('setRegisterRecords', null)
        console.warn('Removed listener for register record')
      }
    },
    getRegisterRecords({ commit, dispatch, state }: { state: any, commit: any, dispatch: any }, date: Date = new Date()) {
      if (state.registerRecordsListener) {
        dispatch('releaseRegisterRecords')
      }
      const q = query(
        paymentsCollGroup,
        where('dateCreated', '>=', startOfDay(date)),
        where('dateCreated', '<=', endOfDay(date))
      )
      const listener = onSnapshot(q, { includeMetadataChanges: true }, async (snapshot) => {
        console.time('getRegisterRecords.onSnapshot')
        const records: RecordItem[] = await getRecordsCollectionSnapShot(snapshot)
        commit('setRegisterRecords', records)
        console.timeEnd('getRegisterRecords.onSnapshot')
      })
      commit('setRegisterRecordsListener', listener)
    }
  }
}
